class WlfEventProduct extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    
    this.slider = this.querySelector('[data-main-slider]');
    this.dots = this.querySelectorAll('.wlf-slider-dot');
    
    this.init();
    this.initSlider();
  }

  init() {
    // Handle Tabs
    this.querySelectorAll('[data-tab-target]').forEach(tab => {
      tab.addEventListener('click', (e) => this.switchTab(e));
    });

    // Handle Accordions
    this.querySelectorAll('[data-accordion-header]').forEach(header => {
      header.addEventListener('click', () => {
        header.parentElement.classList.toggle('is-open');
      });
    });
  }

  switchTab(e) {
    const targetId = e.currentTarget.dataset.tabTarget;
    this.querySelectorAll('[data-tab-target]').forEach(t => t.classList.remove('is-active'));
    e.currentTarget.classList.add('is-active');
    
    this.querySelectorAll('.wlf-event-product__tab-content').forEach(content => {
      content.style.display = content.id === targetId ? 'block' : 'none';
      content.classList.toggle('is-active', content.id === targetId);
    });
  }

  initSlider() {
    if (!this.slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      this.slider.classList.add('is-grabbing');
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
      this.slider.classList.remove('is-grabbing');
    });

    this.slider.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.classList.remove('is-grabbing');
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 2;
      this.slider.scrollLeft = scrollLeft - walk;
    });

    // Sync Dots on Scroll
    this.slider.addEventListener('scroll', () => {
      const index = Math.round(this.slider.scrollLeft / this.slider.offsetWidth);
      this.updateSliderDots(index);
    });

    // Dot Clicks
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index);
        this.slider.scrollTo({
          left: index * this.slider.offsetWidth,
          behavior: 'smooth'
        });
      });
    });
  }

  updateSliderDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  connectedCallback() {
    const isEvent = this.dataset.isEvent === 'true';
    
    // Initialize variantStrings for this specific product if it's an event
    if (isEvent) {
      const priceElement = this.querySelector('.price-item--last') || this.querySelector('.price-item--regular');
      const formattedPrice = priceElement ? priceElement.textContent.trim() : '';
      if (formattedPrice) {
        window.variantStrings = window.variantStrings || {};
        window.variantStrings.addToCart = `Buy Ticket (${formattedPrice})`;
      }
    }

    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      ({ data: { sectionId, variant } }) => {
        const productInfo = this.closest('product-info');
        if (!productInfo || sectionId !== productInfo.dataset.section) return;
        
        // Update Buy Button Text if it's an event
        if (isEvent && variant) {
          // Find the price element. Note: product-info.js already updated it.
          const priceElement = productInfo.querySelector('.price-item--last') || productInfo.querySelector('.price-item--regular');
          const formattedPrice = priceElement ? priceElement.textContent.trim() : '';
          
          if (formattedPrice) {
            window.variantStrings.addToCart = `Buy Ticket (${formattedPrice})`;
          }
          
          const submitButtonText = productInfo.querySelector('product-form button[type="submit"] span');
          if (submitButtonText && !submitButtonText.parentElement.hasAttribute('disabled')) {
            submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }
    );
  }

  disconnectedCallback() {
    if (this.onVariantChangeUnsubscriber) {
      this.onVariantChangeUnsubscriber();
    }
  }
}


customElements.define('wlf-event-product', WlfEventProduct);
